<div class="guide">
  <div class="guide__content">
    <section>
      <header>
        <span>Guide</span>
      </header>

      <ng-content></ng-content>
    </section>
  </div>
  @if (showButton) {
    <button (click)="toggleDetails()">
      @if (showDetails) { Show Less <mat-icon>keyboard_arrow_up </mat-icon> } @else { How to fix
      <mat-icon>expand_more </mat-icon>}
    </button>
  }
</div>
